import {styled} from '@mui/material';

export const SubHeaderContainer = styled('div')`
	background-color: ${({theme}) => theme.palette.background.paper};
	flex-direction: column;
	padding: 16px;
	display: flex;
	gap: 4px;
`;
